export default __webpack_public_path__ + "static/media/mintLogo.5b9d5ae5.svg";